import { render, staticRenderFns } from "./ClientGlucoseCalendar.vue?vue&type=template&id=118fc185&scoped=true"
import script from "./ClientGlucoseCalendar.vue?vue&type=script&lang=js"
export * from "./ClientGlucoseCalendar.vue?vue&type=script&lang=js"
import style0 from "./ClientGlucoseCalendar.vue?vue&type=style&index=0&id=118fc185&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118fc185",
  null
  
)

export default component.exports